import validator from "validator";
import message from "../../../messages/site-publishers";

const validateURL = (url) => {
  if (validator.isEmpty(url)) {
    return message.URL_DOSE_NOT_EXIST;
  }

  if (!url.trim().length) {
    return message.URL_DOSE_NOT_EXIST;
  }

  if (!validator.isURL(url)) {
    return message.URL_INVALID;
  }

  if (!url.includes("https://")) {
    return message.URL_INVALID;
  }

  if (url.charAt(url.length - 1) == "/") {
    return message.URL_INVALID;
  }

  let urlSplit = url.replace("//", "/").split("/");
  if (urlSplit.length != 2) {
    return message.URL_INVALID;
  }
  return true;
};

const validateCategoriesSitePublisher = (categoriesSitePublisher) => {
  if (categoriesSitePublisher.length == 0) {
    return message.CATEGORIES_SITE_PUBLISHERS_DOSE_NOT_ENTER;
  }

  return true;
};

const validateTypeAdvertise = (typeAdvertise) => {
  if (typeAdvertise.length == 0) {
    return message.TYPE_ADVERTISE_DOSE_NOT_ENTER;
  }

  return true;
};

const validateFormAddSitePublishers = (info) => {
  const resValidateUrl = validateURL(info.url);
  if (resValidateUrl != true) {
    return resValidateUrl;
  }

  const resValidateCategoriesSitePublisher = validateCategoriesSitePublisher(
    info.categories_site_publisher
  );
  if (resValidateCategoriesSitePublisher != true) {
    return resValidateCategoriesSitePublisher;
  }

  const resValidateTypeAdvertise = validateTypeAdvertise(info.type_advertise);
  if (resValidateTypeAdvertise != true) {
    return resValidateTypeAdvertise;
  }

  return true;
};

export default validateFormAddSitePublishers;
